

var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


export default getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/util/getDisplayName.js
// module id = 4307
// module chunks = 25